/* ============================================================
   ON FORCE THEME — Core JavaScript
   Cart, Navigation, Search, Gallery, Toast, Variants
   ============================================================ */
(function () {
  'use strict';

  // ---------- HELPERS ----------
  window.ONFORCE = window.ONFORCE || {};
  const settings = window.themeSettings || {};

  function formatMoney(cents) {
    return 'CHF ' + (cents / 100).toFixed(2);
  }
  window.formatMoney = formatMoney;

  const TOAST_ICONS = {
    success: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" width="18" height="18"><polyline points="20 6 9 17 4 12"/></svg>',
    error:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    wish:    '<svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>'
  };
  function showToast(message, type) {
    type = type || 'success';
    const existing = document.querySelector('.toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.className = 'toast toast--' + type;
    toast.innerHTML =
      '<span class="toast__icon">' + (TOAST_ICONS[type] || TOAST_ICONS.success) + '</span>' +
      '<span class="toast__msg">' + message + '</span>';
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }
  window.showToast = showToast;

  // ============================================================
  //  CART SYSTEM
  // ============================================================
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCount(cart.item_count);
      updateCartDrawer(cart);
      updateFreeShippingBar(cart.total_price);
      return cart;
    } catch (e) { /* silent */ }
  }
  window.refreshCart = refreshCart;

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateCartDrawer(cart) {
    const body = document.getElementById('cart-drawer-items');
    const footer = document.getElementById('cart-drawer-footer');
    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="cart-empty cd-empty">' +
        '<p>Dein Warenkorb ist leer.</p>' +
        '<a href="/collections/all" class="btn btn-primary" data-cart-close>Jetzt shoppen</a>' +
        '</div>';

      if (footer) footer.style.display = 'none';
      bindDrawerCloseButtons();
      return;
    }
    if (footer) footer.style.display = 'block';

    body.innerHTML = cart.items.map(item => {
      const variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cd-item__variant">' + item.variant_title + '</div>' : '';
      const img = item.image
        ? '<img src="' + item.image + '" alt="" loading="lazy">' : '';
      const q = item.quantity;
      return '<div class="cd-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cd-item__img">' + img + '</a>' +
        '<div class="cd-item__body">' +
          '<div class="cd-item__top">' +
            '<div class="cd-item__name">' + item.product_title + '</div>' +
            '<div class="cd-item__price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
          variant +
          '<div class="cd-item__bottom">' +
            '<div class="cd-qty">' +
              '<button class="cd-qty__btn" data-change-qty="' + item.key + '" data-qty="' + Math.max(0, q - 1) + '">−</button>' +
              '<span class="cd-qty__val">' + q + '</span>' +
              '<button class="cd-qty__btn" data-change-qty="' + item.key + '" data-qty="' + (q + 1) + '">+</button>' +
            '</div>' +
            '<button class="cd-item__remove" data-change-qty="' + item.key + '" data-qty="0" aria-label="Entfernen">\u00d7</button>' +
          '</div>' +
        '</div>' +
        '</div>';
    }).join('');

    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);

    body.querySelectorAll('[data-change-qty]').forEach(btn => {
      btn.addEventListener('click', () => changeItemQty(btn.dataset.changeQty, parseInt(btn.dataset.qty)));
    });
    bindDrawerCloseButtons();
  }

  function updateFreeShippingBar(totalCents) {
    const goal = (settings.freeShippingGoal || 99) * 100;
    const pct = Math.min(100, Math.round(totalCents / goal * 100));
    const bar = document.getElementById('shipping-progress-fill');
    const msg = document.getElementById('shipping-progress-msg');
    if (bar) bar.style.width = pct + '%';
    if (msg) {
      if (totalCents >= goal) {
        msg.innerHTML = '<span class="success">✓ Du erhältst kostenlosen Versand!</span>';
      } else {
        msg.textContent = 'Noch ' + formatMoney(goal - totalCents) + ' bis zum kostenlosen Versand';
      }
    }
  }

  async function changeItemQty(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCart();
    } catch (e) {
      showToast('Fehler beim Aktualisieren', 'error');
    }
  }
  window.changeItemQty = changeItemQty;

  async function addToCart(variantId, qty) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    });
    if (!res.ok) throw new Error('add failed');
    return res.json();
  }
  window.addToCart = addToCart;

  function openCartDrawer() {
    const d = document.getElementById('cart-drawer');
    const o = document.getElementById('cart-overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCartDrawer() {
    const d = document.getElementById('cart-drawer');
    const o = document.getElementById('cart-overlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  function bindDrawerCloseButtons() {
    document.querySelectorAll('[data-cart-close]').forEach(el => {
      el.onclick = closeCartDrawer;
    });
  }

  function initCart() {
    document.querySelectorAll('[data-cart-open]').forEach(el =>
      el.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); }));
    const overlay = document.getElementById('cart-overlay');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);
    bindDrawerCloseButtons();
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCartDrawer(); });

    // Quick-add buttons on product cards
    document.querySelectorAll('[data-quick-add]').forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault();
        const vId = btn.dataset.quickAdd;
        if (!vId) return;
        try {
          const item = await addToCart(vId, 1);
          await refreshCart();
          openCartDrawer();
          showToast((item.product_title || 'Produkt') + ' hinzugefügt', 'success');
        } catch (err) { showToast('Fehler beim Hinzufügen', 'error'); }
      });
    });
    refreshCart();
  }

  // ============================================================
  //  MOBILE NAV
  // ============================================================
  function initMobileNav() {
    const toggle = document.getElementById('mobile-nav-toggle');
    const nav = document.getElementById('mobile-nav');
    const overlay = document.getElementById('nav-overlay');
    const closeBtn = document.getElementById('mobile-nav-close');
    function open() { if (nav) nav.classList.add('open'); if (overlay) overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { if (nav) nav.classList.remove('open'); if (overlay) overlay.classList.remove('open'); document.body.style.overflow = ''; }
    if (toggle) toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  // ============================================================
  //  HEADER SEARCH (slide-down + predictive)
  // ============================================================
  function initHeaderSearch() {
    const toggle = document.getElementById('search-toggle');
    const bar = document.getElementById('header-search-bar');
    const input = document.getElementById('header-search-input');
    const closeBtn = document.getElementById('search-close');
    const results = document.getElementById('predictive-results');
    if (toggle && bar) {
      toggle.addEventListener('click', () => {
        bar.classList.toggle('open');
        if (bar.classList.contains('open') && input) setTimeout(() => input.focus(), 120);
      });
    }
    if (closeBtn && bar) closeBtn.addEventListener('click', () => bar.classList.remove('open'));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && bar) bar.classList.remove('open'); });

    // NOTE: Predictive search is handled by the definitive "Predictive Search v5"
    // block at the bottom of this file. The old inline implementation was removed
    // here to avoid two listeners fighting over #predictive-results on each keystroke.
  }


  // ============================================================
  //  STICKY HEADER
  // ============================================================
  function initStickyHeader() {
    const header = document.getElementById('site-header');
    if (!header) return;
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ============================================================
  //  QTY SELECTORS (generic)
  // ============================================================
  function initQtySelectors() {
    document.querySelectorAll('.qty-selector[data-standalone]').forEach(sel => {
      const val = sel.querySelector('.qty-val');
      const minus = sel.querySelector('[data-minus]');
      const plus = sel.querySelector('[data-plus]');
      if (minus) minus.addEventListener('click', () => { const v = parseInt(val.textContent); if (v > 1) val.textContent = v - 1; });
      if (plus) plus.addEventListener('click', () => { val.textContent = parseInt(val.textContent) + 1; });
    });
  }

  // ============================================================
  //  PRODUCT GALLERY
  // ============================================================
  function initProductGallery() {
    const main = document.getElementById('gallery-main-img');
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (thumb.dataset.full) main.src = thumb.dataset.full;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
    // Zoom lightbox
    const zoom = document.getElementById('gallery-zoom');
    if (zoom) {
      zoom.addEventListener('click', () => {
        const lb = document.createElement('div');
        lb.className = 'modal-backdrop open';
        lb.style.zIndex = 1300;
        lb.innerHTML = '<img src="' + main.src + '" style="max-width:90vw;max-height:90vh;object-fit:contain;margin:auto;position:absolute;inset:0">';
        lb.addEventListener('click', () => lb.remove());
        document.body.appendChild(lb);
      });
    }
  }

  // ============================================================
  //  PRODUCT VARIANTS
  // ============================================================
  function initVariants() {
    const dataEl = document.getElementById('product-variants-json');
    if (!dataEl) return;
    let allVariants;
    try { allVariants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const optionState = {};
    document.querySelectorAll('.variant-option.active').forEach(opt => {
      optionState[opt.dataset.optionName] = opt.dataset.value;
    });

    document.querySelectorAll('.variant-option').forEach(opt => {
      opt.addEventListener('click', () => {
        const group = opt.closest('.variant-section');
        group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('active'));
        opt.classList.add('active');
        optionState[opt.dataset.optionName] = opt.dataset.value;
        const lbl = group.querySelector('.selected-val');
        if (lbl) lbl.textContent = opt.dataset.value;

        // Direkte Galerie-Umschaltung über das Swatch-Bild (data-variant-img),
        // falls die Variante selbst kein featured_image hat.
        if (opt.dataset.variantImg) {
          const mainImg = document.getElementById('gallery-main-img');
          if (mainImg) mainImg.src = opt.dataset.variantImg;
        }

        const match = allVariants.find(v =>
          Object.keys(optionState).every((name, i) => v.options[i] === optionState[name])
        );

        if (match) updateForVariant(match);
      });
    });

    function updateForVariant(v) {
      // BUGFIX: hidden input wurde nie aktualisiert → Form-Submit & Nährwerte-Swap
      // hingen immer auf der Startvariante
      const fv = document.getElementById('form-variant-id');
      if (fv) fv.value = v.id;
      const priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      const atc = document.getElementById('atc-btn');
      if (atc) {
        atc.dataset.variantId = v.id;
        if (v.available) { atc.disabled = false; atc.textContent = 'In den Warenkorb'; }
        else { atc.disabled = true; atc.textContent = 'Ausverkauft'; }
      }
      // Galerie-Hauptbild auf das Variantenbild umschalten (falls vorhanden)
      var vImg = (v.featured_image && v.featured_image.src) ? v.featured_image.src
               : (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src ? v.featured_media.preview_image.src : null);
      if (vImg) {
        var mainImg = document.getElementById('gallery-main-img');
        if (mainImg) {
          var hi = vImg.indexOf('?') > -1 ? vImg.split('?')[0] : vImg;
          mainImg.src = hi + (hi.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
        }
        document.querySelectorAll('.product-gallery__thumb').forEach(function(t){
          var full = t.dataset.full || '';
          t.classList.toggle('active', full.split('?')[0] === vImg.split('?')[0]);
        });
      }
      updateStock(v);
      try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
    }


    function updateStock(v) {
      const el = document.getElementById('stock-indicator-text');
      if (!el) return;
      const qty = v.inventory_quantity;
      if (v.inventory_management !== 'shopify') { el.className = 'in-stock'; el.textContent = '● Auf Lager'; }
      else if (qty <= 0) { el.className = 'out-of-stock'; el.textContent = '● Ausverkauft'; }
      else if (qty <= 5) { el.className = 'low-stock'; el.textContent = '● Nur noch ' + qty + ' verfügbar'; }
      else { el.className = 'in-stock'; el.textContent = '● Auf Lager — in 1-2 Werktagen bei dir'; }
    }
  }

  // ============================================================
  //  PRODUCT ATC + QTY + STICKY + TABS
  // ============================================================
  function initProductPage() {
    // qty
    const qtyVal = document.getElementById('qty-input');
    const qMinus = document.getElementById('qty-minus');
    const qPlus = document.getElementById('qty-plus');
    if (qMinus && qtyVal) qMinus.addEventListener('click', () => { const v = parseInt(qtyVal.textContent); if (v > 1) qtyVal.textContent = v - 1; });
    if (qPlus && qtyVal) qPlus.addEventListener('click', () => { qtyVal.textContent = parseInt(qtyVal.textContent) + 1; });

    // ATC
    const atc = document.getElementById('atc-btn');
    if (atc) {
      atc.addEventListener('click', async function (e) {
        // Nativen Form-Submit verhindern (Button ist type=submit im {% form 'product' %}),
        // sonst wird zusaetzlich zur /cart-Seite navigiert statt den Drawer zu oeffnen.
        e.preventDefault();
        const vId = this.dataset.variantId;
        const qty = qtyVal ? parseInt(qtyVal.textContent) : 1;
        if (!vId) return;
        this.classList.add('btn--loading');
        try {
          const item = await addToCart(vId, qty);
          await refreshCart();
          openCartDrawer();
          showToast((item.product_title || 'Produkt') + ' hinzugefügt', 'success');
        } catch (e) { showToast('Fehler beim Hinzufügen', 'error'); }
        finally { this.classList.remove('btn--loading'); }
      });
    }

    // Sticky ATC — beobachtet den echten Kaufen-Button, NICHT #product-atc-section:
    // dieser Wrapper hat auf Mobile display:contents (kein eigener Kasten), wodurch
    // IntersectionObserver ihn sofort als "nicht sichtbar" meldet → Sticky-Bar
    // erschien direkt beim Laden statt erst nach dem Scrollen über den Button hinaus.
    const atcAnchor = document.getElementById('atc-btn');
    const sticky = document.getElementById('sticky-atc');
    if (atcAnchor && sticky && 'IntersectionObserver' in window) {
      const obs = new IntersectionObserver(entries => {
        const e = entries[0];
        // Sticky-Bar NUR zeigen, wenn der Kaufen-Button nach OBEN aus dem
        // Viewport gescrollt wurde (boundingClientRect.top < 0). Solange der
        // Button noch weiter unten liegt (z.B. beim Laden auf Mobile), bleibt
        // die Bar aus — sonst erschien sie sofort statt erst nach dem Scrollen.
        const scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('visible', scrolledPast);
      }, { threshold: 0 });
      obs.observe(atcAnchor);
      const sBtn = document.getElementById('sticky-atc-btn');
      if (sBtn && atc) sBtn.addEventListener('click', () => atc.click());
    }

    // Tabs
    document.querySelectorAll('.tab-nav-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.tab;
        document.querySelectorAll('.tab-nav-btn').forEach(b => b.classList.toggle('active', b.dataset.tab === id));
        document.querySelectorAll('.tab-panel').forEach(p => {
          const on = p.id === id;
          p.classList.toggle('active', on);
          p.hidden = !on;
        });
      });
    });
  }

  // ============================================================
  //  FAQ ACCORDION
  // ============================================================
  function initFAQ() {
    document.querySelectorAll('.faq-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faq-item');
        const answer = item.querySelector('.faq-answer');
        const isOpen = item.classList.contains('open');
        if (isOpen) {
          item.classList.remove('open');
          answer.style.maxHeight = '0';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // ============================================================
  //  NEWSLETTER
  // ============================================================
  function initNewsletter() {
    document.querySelectorAll('.newsletter-form').forEach(form => {
      form.addEventListener('submit', async e => {
        // Let Shopify native forms work too; only intercept if data-ajax
        if (!form.hasAttribute('data-ajax')) return;
        e.preventDefault();
        const emailInput = form.querySelector('input[type=email]');
        const btn = form.querySelector('button[type=submit]');
        if (!emailInput) return;
        if (btn) { btn.disabled = true; btn.textContent = '...'; }
        try {
          const body = 'form_type=customer&utf8=✓&contact[email]=' +
            encodeURIComponent(emailInput.value) + '&contact[tags]=newsletter';
          await fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body });
          form.innerHTML = '<p class="success-msg">✓ Angemeldet! Dein Rabattcode kommt per E-Mail.</p>';
        } catch (err) {
          if (btn) { btn.disabled = false; btn.textContent = 'Anmelden'; }
          showToast('Fehler. Bitte erneut versuchen.', 'error');
        }
      });
    });
  }

  // ============================================================
  //  SCROLL REVEAL
  // ============================================================
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(el => el.classList.add('revealed'));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('revealed'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
  }

  // ============================================================
  //  COLLECTION FILTERS
  // ============================================================
  function initCollectionFilters() {
    // Grid toggle
    const grid = document.getElementById('product-grid');
    if (grid) {
      const saved = localStorage.getItem('on_grid_cols');
      if (saved) grid.dataset.cols = saved;
      document.querySelectorAll('[data-grid-cols]').forEach(btn => {
        btn.addEventListener('click', () => {
          grid.dataset.cols = btn.dataset.gridCols;
          localStorage.setItem('on_grid_cols', btn.dataset.gridCols);
        });
      });
    }
    // Mobile filter sheet
    const trigger = document.getElementById('mobile-filter-trigger');
    const sidebar = document.getElementById('filter-sidebar');
    if (trigger && sidebar) {
      trigger.addEventListener('click', () => {
        sidebar.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
      // Close button inside sidebar (added dynamically)
      sidebar.addEventListener('click', (e) => {
        if (e.target.closest('[data-filter-close]')) {
          sidebar.classList.remove('open');
          document.body.style.overflow = '';
        }
      });
    }
    // Sort
    const sort = document.getElementById('sort-by') || document.getElementById('sort-by-head');
    document.querySelectorAll('#sort-by, #sort-by-head, #sort-by-mobile').forEach(function (sel) {

      sel.addEventListener('change', function () {
        const u = new URL(window.location);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
    if (false && sort) {

      sort.addEventListener('change', () => {
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location = url.toString();
      });
    }
    // Auto-apply filters (sofort beim Klick, ohne Button)
    const filterForm = document.getElementById('collection-filter-form');
    if (filterForm && filterForm.hasAttribute('data-auto-submit')) {
      const submitFilters = () => {
        const formData = new FormData(filterForm);
        const params = new URLSearchParams();
        for (const [key, val] of formData.entries()) {
          if (val !== '' && val != null) params.append(key, val);
        }
        const base = window.location.pathname;
        window.location = base + '?' + params.toString();
      };
      let priceTimer;
      filterForm.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
        cb.addEventListener('change', submitFilters);
      });
      filterForm.querySelectorAll('input[type="number"]').forEach((inp) => {
        inp.addEventListener('input', () => {
          clearTimeout(priceTimer);
          priceTimer = setTimeout(submitFilters, 900);
        });
      });
      filterForm.addEventListener('submit', (e) => { e.preventDefault(); submitFilters(); });
    }
  }


  // ============================================================
  //  INIT
  // ============================================================
  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.remove('no-js');
    initCart();
    initMobileNav();
    initHeaderSearch();
    initStickyHeader();
    initQtySelectors();
    initProductGallery();
    initVariants();
    initProductPage();
    initFAQ();
    initNewsletter();
    initScrollReveal();
    initCollectionFilters();
  });
})();

/* ============================================================
   MOBILE NAV ACCORDION
   ============================================================ */
(function() {
  function initMobileNavAccordion() {
    document.querySelectorAll('.mobile-nav__item button.mobile-nav__link').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.mobile-nav__item');
        var isOpen = item.classList.contains('open');
        // Close all
        document.querySelectorAll('.mobile-nav__item.open').forEach(function(i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
        btn.setAttribute('aria-expanded', (!isOpen).toString());
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNavAccordion);
  } else {
    initMobileNavAccordion();
  }
})();

/* ============================================================
   CART PAGE — Upsell Quick-Add
   ============================================================ */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-add-upsell]');
    if (!btn) return;
    var vid = btn.dataset.variantId;
    var title = btn.dataset.productTitle || 'Produkt';
    if (!vid) return;
    btn.disabled = true; btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).then(function(r) { return r.json(); }).then(function() {
      window.showToast && showToast(title + ' hinzugefügt!');
      btn.textContent = '✓ Hinzugefügt';
      // Reload to update upsell + summary
      setTimeout(function() { location.reload(); }, 800);
    }).catch(function() {
      btn.disabled = false; btn.textContent = '+ Hinzufügen';
    });
  });
})();


// ── Predictive Search v5 (3-column, definitive) ───────────────
(function(){
  var input = document.getElementById('header-search-input');
  var box   = document.getElementById('predictive-results');
  if(!input || !box) return;

  var timer, last = '';
  var SUGGESTS = ['whey protein isolate','mass gainer','creatine','pre-workout',
                  'protein riegel','veganes protein','bcaa','fatburner','collagen','vitamin c'];
  var SRCH_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13" style="flex-shrink:0;color:#bbb"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
  var CART_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 001.95-1.57l1.65-8.42H6"/></svg>';

  function chf(c){
    // suggest.json liefert price als String in Franken (z.B. "24.00"),
    // Storefront-Objekte teils in Rappen (Integer). Beides robust behandeln.
    var n = (typeof c === 'string') ? parseFloat(c) : (c / 100);
    if (isNaN(n)) return '';
    return 'CHF\u00a0' + n.toFixed(2).replace('.', ',');
  }

  function esc(s){ return s ? String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;') : ''; }
  function img(u,w){ var s=!u?'':(typeof u==='string'?u:(u.src||u.url||'')); if(!s||s==='[object Object]') return ''; return s+(s.indexOf('?')>-1?'&':'?')+'width='+w; }

  function render(products, q) {
    var brands = (window.ON_BRANDS || []).slice(0,5);
    var bFiltered = q.length > 1 ? brands.filter(function(b){ return b.name.toLowerCase().indexOf(q.toLowerCase()) > -1; }) : brands;
    if(!bFiltered.length) bFiltered = brands.slice(0,5);
    var sFiltered = q.length > 1 ? SUGGESTS.filter(function(s){ return s.indexOf(q.toLowerCase()) > -1; }) : SUGGESTS;
    if(!sFiltered.length) sFiltered = SUGGESTS.slice(0,7);

    var h = '<div class="ps-grid" style="display:grid;grid-template-columns:1.6fr 1fr 1fr;min-height:200px">';

    // Col 1 – Products
    h += '<div class="ps-col ps-col--products" style="padding:20px 0;border-right:1px solid #f0f0f0">';

    h += '<div style="font-size:11px;font-weight:800;letter-spacing:.08em;color:#999;padding:0 20px 10px">TOP PRODUKTE</div>';
    if(products.length) {
      products.slice(0,4).forEach(function(p){
        var src = img(p.image, 88);
        var pimg = src ? '<img src="'+src+'" width="44" height="44" style="width:44px;height:44px;object-fit:contain;background:#f5f5f5;border-radius:8px;flex-shrink:0">' : '<div style="width:44px;height:44px;background:#f5f5f5;border-radius:8px;flex-shrink:0"></div>';
        var price = p.price ? '<span style="font-size:13px;font-weight:800;color:#4a8000;flex-shrink:0">'+chf(p.price)+'</span>' : '';
        h += '<a href="'+esc(p.url)+'" style="display:flex;align-items:center;gap:12px;padding:9px 20px;text-decoration:none;color:inherit" onmouseover="this.style.background=\'#f8f8f8\'" onmouseout="this.style.background=\'\'">'+pimg+'<div style="flex:1;min-width:0;overflow:hidden"><div style="font-size:13px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'+esc(p.title)+'</div><div style="font-size:11px;color:#999">'+esc(p.vendor||'')+'</div></div>'+price+'</a>';
      });
    } else {
      h += '<div style="padding:20px;font-size:13px;color:#bbb">Keine Produkte gefunden</div>';
    }
    h += '</div>';

    // Col 2 – Popular searches
    h += '<div class="ps-col ps-col--suggests" style="padding:20px 0;border-right:1px solid #f0f0f0">';
    h += '<div style="font-size:11px;font-weight:800;letter-spacing:.08em;color:#999;padding:0 20px 10px">BELIEBTE SUCHEN</div>';

    sFiltered.slice(0,7).forEach(function(s){
      h += '<a href="/search?q='+encodeURIComponent(s)+'" style="display:flex;align-items:center;gap:8px;padding:9px 20px;font-size:13px;color:#555;text-decoration:none" onmouseover="this.style.background=\'#f8f8f8\'" onmouseout="this.style.background=\'\'">'+SRCH_ICON+'<span>'+esc(s)+'</span></a>';
    });
    h += '</div>';

    // Col 3 – Brands
    h += '<div style="padding:20px 0">';
    h += '<div style="font-size:11px;font-weight:800;letter-spacing:.08em;color:#999;padding:0 20px 10px">MARKEN</div>';
    bFiltered.forEach(function(b){
      var logo = b.logo ? '<img src="'+img(b.logo,72)+'" style="width:36px;height:24px;object-fit:contain;flex-shrink:0" alt="'+esc(b.name)+'">' : '<div style="width:36px;height:24px;background:#e8f5d4;border-radius:4px;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:800;flex-shrink:0">'+esc(b.name.charAt(0))+'</div>';
      h += '<a href="'+esc(b.url)+'" style="display:flex;align-items:center;gap:10px;padding:9px 20px;text-decoration:none;color:inherit" onmouseover="this.style.background=\'#f8f8f8\'" onmouseout="this.style.background=\'\'">'+logo+'<span style="font-size:13px;font-weight:700">'+esc(b.name)+'</span></a>';
    });
    h += '<a href="/pages/marken" style="display:block;padding:8px 20px;font-size:13px;font-weight:700;color:#4a8000;text-decoration:none">Alle Marken →</a>';
    h += '</div>';
    h += '</div>';

    // Footer
    h += '<div style="border-top:1px solid #f0f0f0"><a href="/search?q='+encodeURIComponent(q)+'" style="display:flex;align-items:center;gap:12px;padding:14px 24px;font-size:14px;font-weight:700;color:#111;text-decoration:none;background:#fafafa" onmouseover="this.style.background=\'#f0f8df\'" onmouseout="this.style.background=\'#fafafa\'">'+CART_ICON+'Alle Ergebnisse f\u00fcr \u201e'+esc(q)+'\u201c anzeigen \u2192</a></div>';

    box.innerHTML = h;
    box.classList.add('is-open');
  }

  function search(q) {
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[options][limit]=4')
      .then(function(r){ return r.json(); })
      .then(function(d){ render((d.resources&&d.resources.results&&d.resources.results.products)||[], q); })
      .catch(function(){ render([], q); });
  }

  function showDefault() { render([], ''); box.classList.add('is-open'); }

  input.addEventListener('input', function(){
    var q = this.value.trim();
    if(q === last) return; last = q;
    clearTimeout(timer);
    if(q.length === 0){ box.classList.remove('is-open'); box.innerHTML = ''; return; }
    if(q.length < 2){ showDefault(); return; }
    timer = setTimeout(function(){ search(q); }, 200);
  });
  input.addEventListener('focus', function(){
    if(this.value.trim().length >= 2) box.classList.add('is-open');
    else showDefault();
  });
  document.addEventListener('click', function(e){
    if(!box.contains(e.target) && !input.contains(e.target)) box.classList.remove('is-open');
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ box.classList.remove('is-open'); input.blur(); }
  });
})();
